@if (contentLoaded) {
	<div class="container">
		<div class="row mb-4">
			<div [innerHTML]="pageConfig.content.introduction"></div>
		</div>

		<div class="row mb-4">
			<div class="py-2 px-0">
				<app-map
					[filters]="filtersStatus"
					[customLayers]="this.layers"
					(customLayerSelected)="this.reactToLayerSelection($event)"
					(mapLoaded)="this.onMapLoad($event)"></app-map>
			</div>
		</div>
		<div class="row mb-4">
			<app-multi-link-accordion [accordion]="pageConfig.content.linkAccordion"></app-multi-link-accordion>
		</div>
		<div class="row mb-4">
			<h2 class="mb-4 title-bottom-line">Filtri</h2>
			<app-filter-group
				[filters]="visibleFilters"
				[filterMapper]="filterMapper"
				(filterChanged)="setNewFilterStatus($event)"
				[asAccordion]="true"></app-filter-group>
		</div>
		@if (showReportError) {
			<div class="row mt-3 justify-content-center">
				<div class="alert alert-danger my-alert m-0" role="alert">
					<span> Non è stato possibile generare il report. Per favore riprova più tardi. </span>
				</div>
			</div>
		}
		<div class="row mt-3 mb-2 justify-content-center gap-2">
			<div class="col-12 col-lg-3 col-md-5 justify-content-center">
				<app-drop-down-button
					[showLoadingSpinner]="showDownloadDataLoadingSpinner"
					[dropdownButton]="this.downloadDataDropdown"></app-drop-down-button>
			</div>
			<div class="col-12 col-lg-3 col-md-5 justify-content-center">
				<app-drop-down-button
					[showLoadingSpinner]="showDownloadMapLoadingSpinner"
					[dropdownButton]="this.downloadMapDropdown"></app-drop-down-button>
			</div>
		</div>
		<!-- <button (click)="this.exportMap('png')">Download img</button> -->
		<div class="row mt-1 mb-4 d-flex justify-content-center">
			NOTA: l'elaborazione potrebbe richiedere più secondi se i filtri impostati sono poco stringenti.
		</div>
	</div>
} @else if (showPageError) {
	<app-page-error></app-page-error>
} @else {
	<app-loading-spinner></app-loading-spinner>
}
